import { Location } from '@angular/common';
import { Component, OnInit, ViewChild } from '@angular/core';
import { MatLegacyCheckboxChange as MatCheckboxChange } from '@angular/material/legacy-checkbox';
import { MatLegacyDialog as MatDialog } from '@angular/material/legacy-dialog';
import { ActivatedRoute, Router } from '@angular/router';
import { DialogCreateCustomCodeComponent } from '@app/shared/components/dialog-create-custom-code/dialog-create-custom-code.component';
import { NoteType } from '@app/shared/components/note/note.interface';
import { RuleEditorComponent } from '@app/shared/components/rule-editor/rule-editor.component';
import { NotificationType } from '@app/shared/interfaces';
import { RuleService } from '@app/shared/services/rule/rule.service';
import { SettingsService } from '@app/shared/services/settings/settings.service';
import { TitleService } from '@app/shared/services/title/title.service';
import { ToastNotificationsService } from '@app/shared/services/toast-notifications/toast-notifications.service';
import { map } from 'rxjs/operators';
import { DialogDeleteRulesetComponent } from '../../components/dialog-delete-ruleset/dialog-delete-ruleset.component';

@Component({
  standalone: false,
  selector: 'sbnb-rule-detail',
  templateUrl: './rule-detail.component.html',
  styleUrls: ['./rule-detail.component.scss'],
})
export class RuleDetailComponent implements OnInit {
  ruleSetId: any;
  ruleSetData: any;
  loading: boolean;
  saveStatus: number;
  lastSaved: Date;
  timingsMeta: any;
  isQuestionRuleset: boolean;
  NoteType = NoteType;

  @ViewChild('ruleEditor') ruleEditor: RuleEditorComponent;

  constructor(
    private location: Location,
    private route: ActivatedRoute,
    private ruleSetService: RuleService,
    public dialog: MatDialog,
    private titleService: TitleService,
    private router: Router,
    private toast: ToastNotificationsService,
    private settingsService: SettingsService
  ) { }

  ngOnInit() {
    this.titleService.manuallySet('Rule detail');

    this.loading = true;

    this.route.params.subscribe((params) => {
      this.ruleSetId = params['id'];
      this.ruleSetService.getRuleSetById(this.ruleSetId).subscribe((res) => {
        this.ruleSetData = res.data;
        this.timingsMeta = res.meta?.timings;
        this.loading = false;

        if (this.ruleSetData.event.startsWith('question')) {
          this.isQuestionRuleset = true;
        }

        this.titleService.manuallySet(this.ruleSetData.name);
      });
    });
  }

  goBack() {
    this.router.navigate(['/gx/rules']);
  }

  openNewCustomCodeDialog() {
    const dialogRef = this.dialog.open(DialogCreateCustomCodeComponent, {
      width: '720px',
      height: '80%',
      data: {},
    });

    dialogRef.afterClosed().subscribe((result) => {
      // Nothing at the mo
    });
  }

  updateRuleSet() {
    this.saveStatus = 1;

    this.ruleSetService.updateRuleSet(this.ruleSetId, this.ruleSetData).subscribe((res: any) => {
      if (res.error) {
        this.saveStatus = -1;
      } else {
        this.saveStatus = 2;
        this.lastSaved = new Date();

        this.ruleSetData = Object.assign({}, this.ruleSetData, res.data);

        setTimeout(() => {
          this.saveStatus = null;
        }, 2000);
      }
    });
  }

  deleteRulesetPrompt() {
    const dialogRef = this.dialog.open(DialogDeleteRulesetComponent, {
      width: '720px',
      data: {
        item: 'Message rule',
      },
    });

    dialogRef.afterClosed().subscribe((result) => {
      if (result) {
        this.deleteRuleset();
      }
    });
  }

  deleteRuleset() {
    this.ruleSetService.deleteRuleset(this.ruleSetId).subscribe((res) => {
      this.location.back();
    });
  }

  ruleSaveStatusChange($event) {
    this.saveStatus = $event;

    if ($event === 2) {
      this.lastSaved = new Date();
    }
  }

  copyRuleset() {
    this.ruleSetService.copyRuleset(this.ruleSetId).subscribe((res) => {
      if (res.data.id) {
        this.router.navigate(['/gx/rule/', res.data.id]);
      }
    });
  }

  handleScopeChange(event) {
    this.ruleSetData.all_platforms = event.all_platforms;
    this.ruleSetData.all_hosts = event.all_hosts;
    this.ruleSetData.all_properties = event.all_properties;
    this.ruleSetData.properties = event.properties;
    this.ruleSetData.hosts = event.hosts;
    this.ruleSetData.platforms = event.platforms;

    this.updateRuleSet();

    setTimeout(() => {
      this.ruleEditor.getImportableData();
    }, 3000);
  }

  handlesettingsChange(newSettings: any) {
    this.ruleSetData.metadata = newSettings;

    this.updateRuleSet();
  }

  timingUpdated($event) {
    this.updateRuleSet();
  }

  activateOrDeactivateRule(event: MatCheckboxChange) {
    this.ruleSetData.active = event.checked;

    this.ruleSetService.activeOrDeactivateRuleset(this.ruleSetId, this.ruleSetData.active).subscribe((res: any) => {
      if (res.success) {
        this.saveStatus = 2;
        setTimeout(() => {
          this.saveStatus = null;
        }, 2500);
        return;
      }

      if (res.error) {
        this.ruleSetData.active = !this.ruleSetData.active;
        this.toast.open(`Oops! We ran into an error updating the Messaging rule`, 'Dismiss', NotificationType.Error);
      }
    });
  }
}
